// // pages/Dashboard.jsx
// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';
// import axios from 'axios';
// import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import EnrollmentStats from '../components/EnrollmentStats';
// import { CONSTANTS } from '../constants/Constants';

// const Dashboard = () => {
//   const { currentUser, userDetails } = useAuth();
//   const navigate = useNavigate();
//   const [isLoading, setIsLoading] = useState(true);
//   const [courses, setCourses] = useState([]);
//   const [examResults, setExamResults] = useState([]);
//   const [recentActivity, setRecentActivity] = useState([]);
//   const [stats, setStats] = useState({
//     coursesEnrolled: 0,
//     coursesCompleted: 0,
//     testsAttempted: 0,
//     averageScore: 0
//   });

//   // Redirect if not logged in
//   useEffect(() => {
//     if (!currentUser && !isLoading) {
//       navigate('/login', { replace: true });
//     }
//   }, [currentUser, navigate, isLoading]);

//   // Fetch user data
//   useEffect(() => {
//     const fetchUserData = async () => {
//       if (!currentUser) return;

//       try {
//         setIsLoading(true);

//         // Fetch enrolled courses

//         const coursesResponse = await axios.get(`${CONSTANTS.APIURL}/api/users/${currentUser.uid}/courses`);

//         // Fetch exam results
//         const examResponse = await axios.get(`${CONSTANTS.APIURL}/api/users/${currentUser.uid}/exam-results`);

//         // Fetch recent activity
//         const activityResponse = await axios.get(`${CONSTANTS.APIURL}/api/users/${currentUser.uid}/activity`);

//         // Set data in state
//         setCourses(coursesResponse.data.courses || []);
//         setExamResults(examResponse.data.examResults || []);
//         setRecentActivity(activityResponse.data.activities || []);

//         // Calculate stats
//         const completedCourses = coursesResponse.data.courses.filter(course => course.completed).length;
//         const totalTests = examResponse.data.examResults.length;
//         const totalScores = examResponse.data.examResults.reduce((sum, exam) => sum + (exam.score / exam.maxScore) * 100, 0);
//         const avgScore = totalTests > 0 ? totalScores / totalTests : 0;

//         setStats({
//           coursesEnrolled: coursesResponse.data.courses.length,
//           coursesCompleted: completedCourses,
//           testsAttempted: totalTests,
//           averageScore: Math.round(avgScore)
//         });

//       } catch (error) {
//         console.error("Error fetching user data:", error);
//         toast.error("Failed to load dashboard data. Please try again.");
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchUserData();
//   }, [currentUser]);

//   // Mock data for demo purposes
//   const mockCourses = [
//     {
//       _id: 'c1',
//       courseId: {
//         _id: 'course1',
//         title: 'NPSC Prelims Comprehensive Course',
//         thumbnail: '/images/courses/prelims.jpg',
//         instructor: 'Dr. Rajesh Verma',
//         totalDuration: '120 hours'
//       },
//       progress: 68,
//       completed: false,
//       lastAccessedAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000)
//     },
//     {
//       _id: 'c2',
//       courseId: {
//         _id: 'course2',
//         title: 'Current Affairs Master Class',
//         thumbnail: '/images/courses/current-affairs.jpg',
//         instructor: 'Prof. Smita Sharma',
//         totalDuration: '48 hours'
//       },
//       progress: 100,
//       completed: true,
//       lastAccessedAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000)
//     },
//     {
//       _id: 'c3',
//       courseId: {
//         _id: 'course3',
//         title: 'Essay Writing Workshop',
//         thumbnail: '/images/courses/essay.jpg',
//         instructor: 'Dr. Amit Kumar',
//         totalDuration: '24 hours'
//       },
//       progress: 32,
//       completed: false,
//       lastAccessedAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000)
//     }
//   ];

//   const mockExamResults = [
//     {
//       _id: 'e1',
//       examId: {
//         _id: 'exam1',
//         title: 'NPSC Prelims Mock Test 1',
//         category: 'Prelims'
//       },
//       score: 78,
//       maxScore: 100,
//       completedAt: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000)
//     },
//     {
//       _id: 'e2',
//       examId: {
//         _id: 'exam2',
//         title: 'Current Affairs Weekly Quiz',
//         category: 'Current Affairs'
//       },
//       score: 85,
//       maxScore: 100,
//       completedAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
//     },
//     {
//       _id: 'e3',
//       examId: {
//         _id: 'exam3',
//         title: 'NPSC Mains Essay Practice',
//         category: 'Mains'
//       },
//       score: 72,
//       maxScore: 100,
//       completedAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000)
//     }
//   ];

//   const mockActivity = [
//     {
//       _id: 'a1',
//       type: 'course_progress',
//       title: 'Continued Course: NPSC Prelims Comprehensive',
//       details: 'Completed Module 7: Indian Economy',
//       timestamp: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000)
//     },
//     {
//       _id: 'a2',
//       type: 'exam_completed',
//       title: 'Completed Test: Current Affairs Weekly Quiz',
//       details: 'Score: 85/100',
//       timestamp: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
//     },
//     {
//       _id: 'a3',
//       type: 'course_enrolled',
//       title: 'Enrolled in Course: Essay Writing Workshop',
//       details: 'By Dr. Amit Kumar',
//       timestamp: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000)
//     },
//     {
//       _id: 'a4',
//       type: 'note_created',
//       title: 'Created Study Notes',
//       details: 'For Indian Polity: Constitutional Framework',
//       timestamp: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000)
//     }
//   ];

//   // Use mock data for demonstration
//   useEffect(() => {
//     if (currentUser && isLoading) {
//       // Simulate API call delay
//       const timer = setTimeout(() => {
//         setCourses(mockCourses);
//         setExamResults(mockExamResults);
//         setRecentActivity(mockActivity);
//         setStats({
//           coursesEnrolled: mockCourses.length,
//           coursesCompleted: mockCourses.filter(course => course.completed).length,
//           testsAttempted: mockExamResults.length,
//           averageScore: Math.round(
//             mockExamResults.reduce((sum, exam) => sum + (exam.score / exam.maxScore) * 100, 0) / mockExamResults.length
//           )
//         });
//         setIsLoading(false);
//       }, 1000);

//       return () => clearTimeout(timer);
//     }
//   }, [currentUser, isLoading]);

//   if (!currentUser) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gray-100">
//         <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-gray-700"></div>
//       </div>
//     );
//   }

//   return (
//     <div className="bg-gray-100 min-h-screen pt-24 pb-12">
//       <ToastContainer position="top-right" autoClose={3000} />

//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         {/* Welcome Section */}
//         <div className="mb-8 mt-8">
//           <h1 className="text-3xl font-bold text-gray-800">
//             Welcome back, {userDetails?.firstName || currentUser.email.split('@')[0]}!
//           </h1>
//           <p className="mt-2 text-gray-600">
//             Here's an overview of your learning journey and recent activities.
//           </p>
//         </div>

//         {/* Stats Section */}
//         <div className="mb-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
//           {/* <div className="bg-white overflow-hidden shadow rounded-lg">
//             <div className="px-4 py-5 sm:p-6">
//               <dl>
//                 <dt className="text-sm font-medium text-gray-500 truncate">Courses Enrolled</dt>
//                 <dd className="mt-1 text-3xl font-semibold text-gray-900">{stats.coursesEnrolled}</dd>
//               </dl>
//             </div>
//             <div className="bg-gray-50 px-4 py-4 sm:px-6">
//               <div className="text-sm">
//                 <Link to="/classroom" className="font-medium text-gray-700 hover:text-gray-900">
//                   Browse more courses
//                 </Link>
//               </div>
//             </div>
//           </div> */}

//           <div className="bg-white overflow-hidden shadow rounded-lg">
//             <div className="px-4 py-5 sm:p-6">
//               <dl>
//                 <dt className="text-sm font-medium text-gray-500 truncate">Courses Completed</dt>
//                 <dd className="mt-1 text-3xl font-semibold text-gray-900">{stats.coursesCompleted}</dd>
//               </dl>
//             </div>
//             <div className="bg-gray-50 px-4 py-4 sm:px-6">
//               <div className="text-sm">
//                 <Link to="/my-certificates" className="font-medium text-gray-700 hover:text-gray-900">
//                   View certificates
//                 </Link>
//               </div>
//             </div>
//           </div>

//           <div className="bg-white overflow-hidden shadow rounded-lg">
//             <div className="px-4 py-5 sm:p-6">
//               <dl>
//                 <dt className="text-sm font-medium text-gray-500 truncate">Tests Attempted</dt>
//                 <dd className="mt-1 text-3xl font-semibold text-gray-900">{stats.testsAttempted}</dd>
//               </dl>
//             </div>
//             <div className="bg-gray-50 px-4 py-4 sm:px-6">
//               <div className="text-sm">
//                 <Link to="/test-series" className="font-medium text-gray-700 hover:text-gray-900">
//                   Take more tests
//                 </Link>
//               </div>
//             </div>
//           </div>

//           <div className="bg-white overflow-hidden shadow rounded-lg">
//             <div className="px-4 py-5 sm:p-6">
//               <dl>
//                 <dt className="text-sm font-medium text-gray-500 truncate">Average Score</dt>
//                 <dd className="mt-1 text-3xl font-semibold text-gray-900">{stats.averageScore}%</dd>
//               </dl>
//             </div>
//             <div className="bg-gray-50 px-4 py-4 sm:px-6">
//               <div className="text-sm">
//                 <Link to="/performance" className="font-medium text-gray-700 hover:text-gray-900">
//                   View detailed analytics
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="mb-8">
//           <EnrollmentStats />
//         </div>
//         {/* Main Content - Two Column Layout */}
//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
//           {/* Left Column */}
//           <div className="lg:col-span-2 space-y-8">
//             {/* My Courses Section */}
//             <div className="bg-white shadow rounded-lg overflow-hidden">
//               <div className="px-6 py-5 border-b border-gray-200 flex justify-between items-center">
//                 <h2 className="text-xl font-bold text-gray-800">My Courses</h2>
//                 <Link
//                   to="/my-courses"
//                   className="text-sm font-medium text-gray-700 hover:text-gray-900"
//                 >
//                   View all
//                 </Link>
//               </div>

//               <div className="divide-y divide-gray-200">
//                 {isLoading ? (
//                   <div className="p-6 flex justify-center">
//                     <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-gray-700"></div>
//                   </div>
//                 ) : courses.length > 0 ? (
//                   courses.slice(0, 3).map((course) => (
//                     <div key={course._id} className="p-6">
//                       <div className="flex items-center">
//                         <div className="flex-shrink-0 h-16 w-16 bg-gray-200 rounded overflow-hidden">
//                           {course.courseId.thumbnail ? (
//                             <img
//                               src={course.courseId.thumbnail}
//                               alt={course.courseId.title}
//                               className="h-full w-full object-cover"
//                             />
//                           ) : (
//                             <div className="h-full w-full flex items-center justify-center bg-gray-300">
//                               <svg className="h-8 w-8 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
//                               </svg>
//                             </div>
//                           )}
//                         </div>
//                         <div className="ml-4 flex-1">
//                           <h3 className="text-lg font-medium text-gray-900">
//                             <Link to={`/course/${course.courseId._id}`} className="hover:underline">
//                               {course.courseId.title}
//                             </Link>
//                           </h3>
//                           <p className="text-sm text-gray-500">
//                             Instructor: {course.courseId.instructor}
//                           </p>
//                           <div className="mt-2">
//                             <div className="flex items-center">
//                               <div className="flex-1 bg-gray-200 rounded-full h-2.5">
//                                 <div
//                                   className="h-2.5 rounded-full bg-gray-800"
//                                   style={{ width: `${course.progress}%` }}
//                                 ></div>
//                               </div>
//                               <span className="ml-2 text-sm text-gray-600">{course.progress}%</span>
//                             </div>
//                           </div>
//                         </div>

//                         <div className="ml-4 flex-shrink-0">
//                           {course.completed ? (
//                             <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
//                               Completed
//                             </span>
//                           ) : (
//                             <Link
//                               to={`/course/${course.courseId._id}/continue`}
//                               className="inline-flex items-center px-3 py-1.5 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none"
//                             >
//                               Continue
//                             </Link>
//                           )}
//                         </div>
//                       </div>
//                     </div>
//                   ))
//                 ) : (
//                   <div className="p-6 text-center">
//                     <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
//                     </svg>
//                     <h3 className="mt-2 text-sm font-medium text-gray-900">No courses found</h3>
//                     <p className="mt-1 text-sm text-gray-500">Get started by enrolling in a course.</p>
//                     <div className="mt-6">
//                       <Link
//                         to="/classroom"
//                         className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gray-800 hover:bg-gray-700 focus:outline-none"
//                       >
//                         Browse Courses
//                       </Link>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* Recent Test Results */}
//             <div className="bg-white shadow rounded-lg overflow-hidden">
//               <div className="px-6 py-5 border-b border-gray-200 flex justify-between items-center">
//                 <h2 className="text-xl font-bold text-gray-800">Recent Test Results</h2>
//                 <Link
//                   to="/test-results"
//                   className="text-sm font-medium text-gray-700 hover:text-gray-900"
//                 >
//                   View all
//                 </Link>
//               </div>

//               <div className="overflow-hidden">
//                 {isLoading ? (
//                   <div className="p-6 flex justify-center">
//                     <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-gray-700"></div>
//                   </div>
//                 ) : examResults.length > 0 ? (
//                   <div className="overflow-x-auto">
//                     <table className="min-w-full divide-y divide-gray-200">
//                       <thead className="bg-gray-50">
//                         <tr>
//                           <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                             Test Name
//                           </th>
//                           <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                             Category
//                           </th>
//                           <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                             Score
//                           </th>
//                           <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                             Date
//                           </th>
//                         </tr>
//                       </thead>
//                       <tbody className="bg-white divide-y divide-gray-200">
//                         {examResults.map((result) => {
//                           const scorePercentage = (result.score / result.maxScore) * 100;
//                           let scoreColorClass = 'text-red-600';

//                           if (scorePercentage >= 80) {
//                             scoreColorClass = 'text-green-600';
//                           } else if (scorePercentage >= 60) {
//                             scoreColorClass = 'text-yellow-600';
//                           } else if (scorePercentage >= 40) {
//                             scoreColorClass = 'text-orange-600';
//                           }

//                           return (
//                             <tr key={result._id}>
//                               <td className="px-6 py-4 whitespace-nowrap">
//                                 <div className="text-sm font-medium text-gray-900">
//                                   <Link to={`/test-results/${result._id}`} className="hover:underline">
//                                     {result.examId.title}
//                                   </Link>
//                                 </div>
//                               </td>
//                               <td className="px-6 py-4 whitespace-nowrap">
//                                 <div className="text-sm text-gray-500">{result.examId.category}</div>
//                               </td>
//                               <td className="px-6 py-4 whitespace-nowrap">
//                                 <div className={`text-sm font-medium ${scoreColorClass}`}>
//                                   {result.score}/{result.maxScore} ({Math.round(scorePercentage)}%)
//                                 </div>
//                               </td>
//                               <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                                 {new Date(result.completedAt).toLocaleDateString()}
//                               </td>
//                             </tr>
//                           );
//                         })}
//                       </tbody>
//                     </table>
//                   </div>
//                 ) : (
//                   <div className="p-6 text-center">
//                     <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
//                     </svg>
//                     <h3 className="mt-2 text-sm font-medium text-gray-900">No test results found</h3>
//                     <p className="mt-1 text-sm text-gray-500">Start taking tests to see your results here.</p>
//                     <div className="mt-6">
//                       <Link
//                         to="/test-series"
//                         className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gray-800 hover:bg-gray-700 focus:outline-none"
//                       >
//                         Take a Test
//                       </Link>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* Right Column */}
//           <div className="space-y-8">
//             {/* Profile Overview */}
//             <div className="bg-white shadow rounded-lg overflow-hidden">
//               <div className="px-6 py-5 border-b border-gray-200">
//                 <h2 className="text-xl font-bold text-gray-800">Profile Overview</h2>
//               </div>

//               <div className="p-6">
//                 <div className="flex items-center">
//                   <div className="flex-shrink-0">
//                     {userDetails?.photoURL ? (
//                       <img
//                         src={userDetails.photoURL}
//                         alt={`${userDetails.firstName} ${userDetails.lastName}`}
//                         className="h-16 w-16 rounded-full object-cover"
//                       />
//                     ) : (
//                       <div className="h-16 w-16 rounded-full bg-gray-700 flex items-center justify-center text-white text-lg font-semibold">
//                         {userDetails?.firstName?.charAt(0)}{userDetails?.lastName?.charAt(0)}
//                       </div>
//                     )}
//                   </div>
//                   <div className="ml-4">
//                     <h3 className="text-lg font-medium text-gray-900">
//                       {userDetails?.firstName} {userDetails?.lastName}
//                     </h3>
//                     <p className="text-sm text-gray-500">{currentUser.email}</p>
//                   </div>
//                 </div>

//                 <div className="mt-6">
//                   <h4 className="text-sm font-medium text-gray-500">Profile Completeness</h4>
//                   <div className="mt-2">
//                     <div className="flex items-center">
//                       <div className="flex-1 bg-gray-200 rounded-full h-2.5">
//                         <div
//                           className="h-2.5 rounded-full bg-gray-800"
//                           style={{ width: `${userDetails?.profileCompleted ? 100 : 60}%` }}
//                         ></div>
//                       </div>
//                       <span className="ml-2 text-sm text-gray-500">
//                         {userDetails?.profileCompleted ? '100%' : '60%'}
//                       </span>
//                     </div>
//                   </div>
//                   {!userDetails?.profileCompleted && (
//                     <p className="mt-2 text-sm text-gray-500">
//                       Complete your profile to get personalized recommendations.
//                     </p>
//                   )}
//                 </div>

//                 <div className="mt-6">
//                   <Link
//                     to="/profile"
//                     className="block w-full text-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none"
//                   >
//                     View Profile
//                   </Link>
//                 </div>
//               </div>
//             </div>

//             {/* Recent Activity */}
//             <div className="bg-white shadow rounded-lg overflow-hidden">
//               <div className="px-6 py-5 border-b border-gray-200">
//                 <h2 className="text-xl font-bold text-gray-800">Recent Activity</h2>
//               </div>

//               <div className="p-6">
//                 {isLoading ? (
//                   <div className="flex justify-center">
//                     <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-gray-700"></div>
//                   </div>
//                 ) : recentActivity.length > 0 ? (
//                   <div className="flow-root">
//                     <ul className="-mb-8">
//                       {recentActivity.map((activity, activityIdx) => (
//                         <li key={activity._id}>
//                           <div className="relative pb-8">
//                             {activityIdx !== recentActivity.length - 1 ? (
//                               <span className="absolute top-5 left-5 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
//                             ) : null}
//                             <div className="relative flex items-start space-x-3">
//                               <div className="relative">
//                                 <div className={`h-10 w-10 rounded-full flex items-center justify-center ${
//                                   activity.type === 'course_progress'
//                                     ? 'bg-blue-100'
//                                     : activity.type === 'exam_completed'
//                                     ? 'bg-green-100'
//                                     : activity.type === 'course_enrolled'
//                                     ? 'bg-purple-100'
//                                     : 'bg-yellow-100'
//                                 }`}>
//                                   {activity.type === 'course_progress' && (
//                                     <svg className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
//                                     </svg>
//                                   )}
//                                   {activity.type === 'exam_completed' && (
//                                     <svg className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
//                                     </svg>
//                                   )}
//                                   {activity.type === 'course_enrolled' && (
//                                     <svg className="h-6 w-6 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
//                                     </svg>
//                                   )}
//                                   {activity.type === 'note_created' && (
//                                     <svg className="h-6 w-6 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
//                                     </svg>
//                                   )}
//                                 </div>
//                               </div>
//                               <div className="min-w-0 flex-1">
//                                 <div>
//                                   <div className="text-sm font-medium text-gray-900">
//                                     {activity.title}
//                                   </div>
//                                   <p className="mt-0.5 text-sm text-gray-500">
//                                     {activity.details}
//                                   </p>
//                                 </div>
//                                 <div className="mt-2 text-sm text-gray-500">
//                                   <p>{new Date(activity.timestamp).toLocaleDateString()}</p>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 ) : (
//                   <div className="text-center py-4">
//                     <p className="text-sm text-gray-500">No recent activity</p>
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* Upcoming Events */}
//             <div className="bg-white shadow rounded-lg overflow-hidden">
//               <div className="px-6 py-5 border-b border-gray-200">
//                 <h2 className="text-xl font-bold text-gray-800">Upcoming Events</h2>
//               </div>

//               <div className="p-6">
//                 <ul className="divide-y divide-gray-200">
//                   <li className="py-4 flex">
//                     <div className="flex-shrink-0 mr-4 flex flex-col items-center">
//                       <span className="text-sm font-semibold text-gray-500">MAY</span>
//                       <span className="text-2xl font-bold text-gray-800">12</span>
//                     </div>
//                     <div>
//                       <p className="text-sm font-medium text-gray-900">NPSC Prelims Live Revision Session</p>
//                       <p className="text-sm text-gray-500">10:00 AM - 12:00 PM</p>
//                     </div>
//                   </li>
//                   <li className="py-4 flex">
//                     <div className="flex-shrink-0 mr-4 flex flex-col items-center">
//                       <span className="text-sm font-semibold text-gray-500">MAY</span>
//                       <span className="text-2xl font-bold text-gray-800">15</span>
//                     </div>
//                     <div>
//                       <p className="text-sm font-medium text-gray-900">Current Affairs Monthly Quiz</p>
//                       <p className="text-sm text-gray-500">2:00 PM - 3:30 PM</p>
//                     </div>
//                   </li>
//                   <li className="py-4 flex">
//                     <div className="flex-shrink-0 mr-4 flex flex-col items-center">
//                       <span className="text-sm font-semibold text-gray-500">MAY</span>
//                       <span className="text-2xl font-bold text-gray-800">20</span>
//                     </div>
//                     <div>
//                       <p className="text-sm font-medium text-gray-900">Mock Interview Workshop</p>
//                       <p className="text-sm text-gray-500">11:00 AM - 1:30 PM</p>
//                     </div>
//                   </li>
//                 </ul>

//                 <div className="mt-6">
//                   <Link
//                     to="/calendar"
//                     className="block w-full text-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none"
//                   >
//                     View Calendar
//                   </Link>
//                 </div>
//               </div>
//             </div>

//             {/* Recommended Resources */}
//             <div className="bg-white shadow rounded-lg overflow-hidden">
//               <div className="px-6 py-5 border-b border-gray-200">
//                 <h2 className="text-xl font-bold text-gray-800">Recommended Resources</h2>
//               </div>

//               <div className="p-6">
//                 <ul className="divide-y divide-gray-200">
//                   <li className="py-4">
//                     <div className="flex items-center">
//                       <div className="flex-shrink-0 h-10 w-10 bg-gray-200 rounded flex items-center justify-center">
//                         <svg className="h-6 w-6 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
//                         </svg>
//                       </div>
//                       <div className="ml-3">
//                         <p className="text-sm font-medium text-gray-900">NPSC Syllabus Analysis PDF</p>
//                         <p className="text-sm text-gray-500">Updated for 2025 examination</p>
//                       </div>
//                     </div>
//                   </li>
//                   <li className="py-4">
//                     <div className="flex items-center">
//                       <div className="flex-shrink-0 h-10 w-10 bg-gray-200 rounded flex items-center justify-center">
//                         <svg className="h-6 w-6 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
//                         </svg>
//                       </div>
//                       <div className="ml-3">
//                         <p className="text-sm font-medium text-gray-900">Art & Culture Quick Revision Video</p>
//                         <p className="text-sm text-gray-500">36 minutes</p>
//                       </div>
//                     </div>
//                   </li>
//                   <li className="py-4">
//                     <div className="flex items-center">
//                       <div className="flex-shrink-0 h-10 w-10 bg-gray-200 rounded flex items-center justify-center">
//                         <svg className="h-6 w-6 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
//                         </svg>
//                       </div>
//                       <div className="ml-3">
//                         <p className="text-sm font-medium text-gray-900">Current Affairs Monthly Digest</p>
//                         <p className="text-sm text-gray-500">April 2025 Edition</p>
//                       </div>
//                     </div>
//                   </li>
//                 </ul>

//                 <div className="mt-6">
//                   <Link
//                     to="/resources"
//                     className="block w-full text-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none"
//                   >
//                     View All Resources
//                   </Link>
//                 </div>
//               </div>
//             </div>

//             {/* Study Streak */}
//             <div className="bg-white shadow rounded-lg overflow-hidden">
//               <div className="px-6 py-5 border-b border-gray-200">
//                 <h2 className="text-xl font-bold text-gray-800">Study Streak</h2>
//               </div>

//               <div className="p-6">
//                 <div className="flex items-center">
//                   <div className="flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-md bg-gray-800 text-white">
//                     <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
//                     </svg>
//                   </div>
//                   <div className="ml-4">
//                     <h3 className="text-lg font-medium leading-6 text-gray-900">7 Days</h3>
//                     <p className="text-sm text-gray-500">Current streak</p>
//                   </div>
//                 </div>

//                 <div className="mt-6">
//                   <div className="grid grid-cols-7 gap-1 text-center">
//                     {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((day, index) => (
//                       <div key={index} className="text-xs font-medium text-gray-500">
//                         {day}
//                       </div>
//                     ))}
//                     {Array.from({ length: 7 }).map((_, index) => (
//                       <div
//                         key={index}
//                         className={`h-8 rounded-sm ${index < 5 ? 'bg-gray-800' : 'bg-gray-200'}`}
//                       >
//                       </div>
//                     ))}
//                   </div>
//                   <p className="mt-2 text-xs text-gray-500 text-center">
//                     Last 7 days
//                   </p>
//                 </div>

//                 <div className="mt-6">
//                   <div className="flex justify-between text-sm">
//                     <span className="font-medium text-gray-700">Consistency Score:</span>
//                     <span className="font-medium text-gray-700">86%</span>
//                   </div>
//                   <div className="mt-1 bg-gray-200 rounded-full h-2">
//                     <div className="bg-gray-800 h-2 rounded-full" style={{ width: '86%' }}></div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Study Plan - Full Width Bottom Section */}
//         <div className="mt-8 bg-white shadow rounded-lg overflow-hidden">
//           <div className="px-6 py-5 border-b border-gray-200 flex justify-between items-center">
//             <h2 className="text-xl font-bold text-gray-800">Weekly Study Plan</h2>
//             <Link
//               to="/study-plan"
//               className="text-sm font-medium text-gray-700 hover:text-gray-900"
//             >
//               Customize Plan
//             </Link>
//           </div>

//           <div className="px-6 py-5">
//             <div className="grid grid-cols-1 md:grid-cols-7 gap-4">
//               {[
//                 {
//                   day: 'Monday',
//                   focus: 'Indian Polity',
//                   time: '2 hours',
//                   completed: true
//                 },
//                 {
//                   day: 'Tuesday',
//                   focus: 'Economy & Current Affairs',
//                   time: '2.5 hours',
//                   completed: true
//                 },
//                 {
//                   day: 'Wednesday',
//                   focus: 'Geography & Environment',
//                   time: '2 hours',
//                   completed: false
//                 },
//                 {
//                   day: 'Thursday',
//                   focus: 'History & Art and Culture',
//                   time: '2 hours',
//                   completed: false
//                 },
//                 {
//                   day: 'Friday',
//                   focus: 'Ethics & Essay Writing',
//                   time: '1.5 hours',
//                   completed: false
//                 },
//                 {
//                   day: 'Saturday',
//                   focus: 'Science & Technology',
//                   time: '1 hour',
//                   completed: false
//                 },
//                 {
//                   day: 'Sunday',
//                   focus: 'Revision & Test',
//                   time: '3 hours',
//                   completed: false
//                 }
//               ].map((item, index) => (
//                 <div key={index} className={`p-4 rounded-lg ${
//                   item.completed ? 'bg-gray-100' : 'bg-white border border-gray-200'
//                 }`}>
//                   <h3 className="font-medium text-gray-900">{item.day}</h3>
//                   <p className="mt-1 text-sm text-gray-600">{item.focus}</p>
//                   <div className="mt-2 flex items-center justify-between">
//                     <span className="text-xs text-gray-500">{item.time}</span>
//                     {item.completed ? (
//                       <span className="inline-flex items-center text-xs font-medium text-green-600">
//                         <svg className="mr-1 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
//                         </svg>
//                         Completed
//                       </span>
//                     ) : (
//                       <span className="text-xs font-medium text-gray-500">Pending</span>
//                     )}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Dashboard;

// pages/Dashboard.jsx
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  collection,
  query,
  where,
  getDocs,
  orderBy,
  limit,
} from "firebase/firestore";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CONSTANTS } from "../constants/Constants";
import { db } from "../firebaseConfig";

const Dashboard = () => {
  const { currentUser, userDetails } = useAuth();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [enrollments, setEnrollments] = useState([]);
  const [testResults, setTestResults] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [stats, setStats] = useState({
    totalEnrollments: 0,
    coursesCompleted: 0,
    testsAttempted: 0,
    averageScore: 0,
    totalBookings: 0,
    averageRank: 0,
  });

  // Redirect if not logged in
  useEffect(() => {
    if (!currentUser && !isLoading) {
      navigate("/login", { replace: true });
    }
  }, [currentUser, navigate, isLoading]);

  // Fetch user data
  useEffect(() => {
    const fetchUserData = async () => {
      if (!currentUser) return;

      try {
        setIsLoading(true);

        // Fetch enrolled courses (original API)
        const coursesResponse = await axios.get(
          `${CONSTANTS.APIURL}/api/users/${currentUser.uid}/courses`
        );

        // Fetch exam results (original API)
        const examResponse = await axios.get(
          `${CONSTANTS.APIURL}/api/users/${currentUser.uid}/exam-results`
        );

        // Fetch recent activity (original API)
        const activityResponse = await axios.get(
          `${CONSTANTS.APIURL}/api/users/${currentUser.uid}/activity`
        );

        // Fetch test results from Firestore
        const testResultsQuery = query(
          collection(db, "testResults"),
          where("userId", "==", currentUser.uid),
          orderBy("submittedAt", "desc"),
          limit(10)
        );
        const testResultsSnapshot = await getDocs(testResultsQuery);
        const testResultsData = testResultsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // Fetch bookings from Firestore
        const bookingsQuery = query(
          collection(db, "bookings"),
          where("userId", "==", currentUser.uid),
          orderBy("createdAt", "desc"),
          limit(10)
        );
        const bookingsSnapshot = await getDocs(bookingsQuery);
        const bookingsData = bookingsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // Set data in state
        setEnrollments(coursesResponse.data.courses || []);
        setTestResults(testResultsData);
        setBookings(bookingsData);

        // Calculate stats
        const completedCourses =
          coursesResponse.data.courses?.filter((course) => course.completed)
            .length || 0;
        const totalTests = testResultsData.length;
        const avgScore =
          totalTests > 0
            ? testResultsData.reduce(
                (sum, test) => sum + (test.percentage || 0),
                0
              ) / totalTests
            : 0;
        const avgRank =
          totalTests > 0
            ? testResultsData.reduce((sum, test) => sum + (test.rank || 0), 0) /
              totalTests
            : 0;

        setStats({
          totalEnrollments: coursesResponse.data.courses?.length || 0,
          coursesCompleted: completedCourses,
          testsAttempted: totalTests,
          averageScore: Math.round(avgScore),
          totalBookings: bookingsData.length,
          averageRank: Math.round(avgRank),
        });
      } catch (error) {
        console.error("Error fetching user data:", error);
        toast.error("Failed to load dashboard data. Please try again.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserData();
  }, [currentUser]);

  if (!currentUser) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-gray-700"></div>
      </div>
    );
  }

  return (
    <div className="bg-gray-100 min-h-screen pt-24 pb-12">
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Welcome Section */}
        <div className="mb-8 mt-8">
          <h1 className="text-3xl font-bold text-gray-800">
            Welcome back,{" "}
            {userDetails?.firstName || currentUser.email.split("@")[0]}!
          </h1>
          <p className="mt-2 text-gray-600">
            Here's an overview of your learning journey and recent activities.
          </p>
        </div>

        {/* Stats Section */}
        <div className="mb-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5">
          <div className="bg-white overflow-hidden shadow rounded-lg">
            <div className="px-4 py-5 sm:p-6">
              <dl>
                <dt className="text-sm font-medium text-gray-500 truncate">
                  Courses Enrolled
                </dt>
                <dd className="mt-1 text-3xl font-semibold text-gray-900">
                  {stats.totalEnrollments}
                </dd>
              </dl>
            </div>
            <div className="bg-gray-50 px-4 py-4 sm:px-6">
              <div className="text-sm">
                <Link
                  to="/classroom"
                  className="font-medium text-gray-700 hover:text-gray-900"
                >
                  Browse more courses
                </Link>
              </div>
            </div>
          </div>

          <div className="bg-white overflow-hidden shadow rounded-lg">
            <div className="px-4 py-5 sm:p-6">
              <dl>
                <dt className="text-sm font-medium text-gray-500 truncate">
                  Courses Completed
                </dt>
                <dd className="mt-1 text-3xl font-semibold text-gray-900">
                  {stats.coursesCompleted}
                </dd>
              </dl>
            </div>
            <div className="bg-gray-50 px-4 py-4 sm:px-6">
              <div className="text-sm">
                <Link
                  to="/my-certificates"
                  className="font-medium text-gray-700 hover:text-gray-900"
                >
                  View certificates
                </Link>
              </div>
            </div>
          </div>

          <div className="bg-white overflow-hidden shadow rounded-lg">
            <div className="px-4 py-5 sm:p-6">
              <dl>
                <dt className="text-sm font-medium text-gray-500 truncate">
                  Tests Attempted
                </dt>
                <dd className="mt-1 text-3xl font-semibold text-gray-900">
                  {stats.testsAttempted}
                </dd>
              </dl>
            </div>
            <div className="bg-gray-50 px-4 py-4 sm:px-6">
              <div className="text-sm">
                <Link
                  to="/test-series"
                  className="font-medium text-gray-700 hover:text-gray-900"
                >
                  Take more tests
                </Link>
              </div>
            </div>
          </div>

          <div className="bg-white overflow-hidden shadow rounded-lg">
            <div className="px-4 py-5 sm:p-6">
              <dl>
                <dt className="text-sm font-medium text-gray-500 truncate">
                  Average Score
                </dt>
                <dd className="mt-1 text-3xl font-semibold text-gray-900">
                  {stats.averageScore}%
                </dd>
              </dl>
            </div>
            <div className="bg-gray-50 px-4 py-4 sm:px-6">
              <div className="text-sm">
                <Link
                  to="/performance"
                  className="font-medium text-gray-700 hover:text-gray-900"
                >
                  View detailed analytics
                </Link>
              </div>
            </div>
          </div>

          <div className="bg-white overflow-hidden shadow rounded-lg">
            <div className="px-4 py-5 sm:p-6">
              <dl>
                <dt className="text-sm font-medium text-gray-500 truncate">
                  Sessions Booked
                </dt>
                <dd className="mt-1 text-3xl font-semibold text-gray-900">
                  {stats.totalBookings}
                </dd>
              </dl>
            </div>
            <div className="bg-gray-50 px-4 py-4 sm:px-6">
              <div className="text-sm">
                <Link
                  to="/mentoring"
                  className="font-medium text-gray-700 hover:text-gray-900"
                >
                  Book session
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content - Two Column Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Left Column */}
          <div className="lg:col-span-2 space-y-8">
            {/* My Courses Section */}
            <div className="bg-white shadow rounded-lg overflow-hidden">
              <div className="px-6 py-5 border-b border-gray-200 flex justify-between items-center">
                <h2 className="text-xl font-bold text-gray-800">My Courses</h2>
                <Link
                  to="/my-courses"
                  className="text-sm font-medium text-gray-700 hover:text-gray-900"
                >
                  View all
                </Link>
              </div>

              <div className="divide-y divide-gray-200">
                {isLoading ? (
                  <div className="p-6 flex justify-center">
                    <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-gray-700"></div>
                  </div>
                ) : enrollments.length > 0 ? (
                  enrollments.map((course) => (
                    <div key={course._id} className="p-6">
                      <div className="flex items-center">
                        <div className="flex-shrink-0 h-16 w-16 bg-gray-200 rounded overflow-hidden">
                          {course.courseId?.thumbnail ? (
                            <img
                              src={course.courseId.thumbnail}
                              alt={course.courseId.title}
                              className="h-full w-full object-cover"
                            />
                          ) : (
                            <div className="h-full w-full flex items-center justify-center bg-gray-300">
                              <svg
                                className="h-8 w-8 text-gray-500"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                                />
                              </svg>
                            </div>
                          )}
                        </div>
                        <div className="ml-4 flex-1">
                          <h3 className="text-lg font-medium text-gray-900">
                            <Link
                              to={`/course/${course.courseId?._id}`}
                              className="hover:underline"
                            >
                              {course.courseId?.title}
                            </Link>
                          </h3>
                          <p className="text-sm text-gray-500">
                            Instructor: {course.courseId?.instructor}
                          </p>
                          <div className="mt-2">
                            <div className="flex items-center">
                              <div className="flex-1 bg-gray-200 rounded-full h-2.5">
                                <div
                                  className="h-2.5 rounded-full bg-gray-800"
                                  style={{ width: `${course.progress || 0}%` }}
                                ></div>
                              </div>
                              <span className="ml-2 text-sm text-gray-600">
                                {course.progress || 0}%
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="ml-4 flex-shrink-0">
                          {course.completed ? (
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                              Completed
                            </span>
                          ) : (
                            <Link
                              to={`/course/${course.courseId?._id}/continue`}
                              className="inline-flex items-center px-3 py-1.5 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none"
                            >
                              Continue
                            </Link>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="p-6 text-center">
                    <svg
                      className="mx-auto h-12 w-12 text-gray-400"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                      />
                    </svg>
                    <h3 className="mt-2 text-sm font-medium text-gray-900">
                      No courses found
                    </h3>
                    <p className="mt-1 text-sm text-gray-500">
                      Get started by enrolling in a course.
                    </p>
                    <div className="mt-6">
                      <Link
                        to="/classroom"
                        className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gray-800 hover:bg-gray-700 focus:outline-none"
                      >
                        Browse Courses
                      </Link>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Recent Test Results */}
            <div className="bg-white shadow rounded-lg overflow-hidden">
              <div className="px-6 py-5 border-b border-gray-200 flex justify-between items-center">
                <h2 className="text-xl font-bold text-gray-800">
                  Recent Test Results
                </h2>
                <Link
                  to="/test-results"
                  className="text-sm font-medium text-gray-700 hover:text-gray-900"
                >
                  View all
                </Link>
              </div>

              <div className="overflow-hidden">
                {isLoading ? (
                  <div className="p-6 flex justify-center">
                    <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-gray-700"></div>
                  </div>
                ) : testResults.length > 0 ? (
                  <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Test
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Score
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Rank
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Date
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {testResults.slice(0, 5).map((result) => {
                          const scoreColorClass =
                            result.percentage >= 80
                              ? "text-green-600"
                              : result.percentage >= 60
                              ? "text-yellow-600"
                              : result.percentage >= 40
                              ? "text-orange-600"
                              : "text-red-600";

                          return (
                            <tr key={result.id}>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <div className="text-sm font-medium text-gray-900">
                                  Test #{result.testId?.slice(-6) || "Unknown"}
                                </div>
                                <div className="text-sm text-gray-500">
                                  Grade: {result.grade || "N/A"}
                                </div>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <div
                                  className={`text-sm font-medium ${scoreColorClass}`}
                                >
                                  {result.obtainedMarks || 0}/
                                  {result.totalMarks || 0} (
                                  {result.percentage || 0}%)
                                </div>
                                <div className="text-sm text-gray-500">
                                  Accuracy: {result.accuracy || 0}%
                                </div>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <div className="text-sm text-gray-900">
                                  #{result.rank || "N/A"}
                                </div>
                                <div className="text-sm text-gray-500">
                                  of {result.totalAppeared || 0}
                                </div>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                {result.submittedAt?.toDate
                                  ? result.submittedAt
                                      .toDate()
                                      .toLocaleDateString()
                                  : "N/A"}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="p-6 text-center">
                    <svg
                      className="mx-auto h-12 w-12 text-gray-400"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
                      />
                    </svg>
                    <h3 className="mt-2 text-sm font-medium text-gray-900">
                      No test results found
                    </h3>
                    <p className="mt-1 text-sm text-gray-500">
                      Start taking tests to see your results here.
                    </p>
                    <div className="mt-6">
                      <Link
                        to="/test-series"
                        className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gray-800 hover:bg-gray-700"
                      >
                        Take a Test
                      </Link>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="space-y-8">
            {/* Test Performance Insights */}
            <div className="bg-white shadow rounded-lg overflow-hidden">
              <div className="px-6 py-5 border-b border-gray-200">
                <h2 className="text-xl font-bold text-gray-800">
                  Performance Insights
                </h2>
              </div>

              <div className="p-6">
                {testResults.length > 0 ? (
                  <div className="space-y-4">
                    {/* Latest test performance */}
                    <div className="border rounded-lg p-4 bg-gray-50">
                      <h4 className="font-medium text-gray-900 mb-2">
                        Latest Test Performance
                      </h4>
                      <div className="space-y-2">
                        <div className="flex justify-between text-sm">
                          <span>Accuracy:</span>
                          <span className="font-medium">
                            {testResults[0]?.accuracy || 0}%
                          </span>
                        </div>
                        <div className="flex justify-between text-sm">
                          <span>Time Taken:</span>
                          <span className="font-medium">
                            {testResults[0]?.timeTaken || "N/A"}
                          </span>
                        </div>
                        <div className="flex justify-between text-sm">
                          <span>Grade:</span>
                          <span className="font-medium">
                            {testResults[0]?.grade || "N/A"}
                          </span>
                        </div>
                        <div className="flex justify-between text-sm">
                          <span>Correct:</span>
                          <span className="font-medium text-green-600">
                            {testResults[0]?.correctAnswers || 0}
                          </span>
                        </div>
                        <div className="flex justify-between text-sm">
                          <span>Incorrect:</span>
                          <span className="font-medium text-red-600">
                            {testResults[0]?.incorrectAnswers || 0}
                          </span>
                        </div>
                        <div className="flex justify-between text-sm">
                          <span>Unattempted:</span>
                          <span className="font-medium text-gray-600">
                            {testResults[0]?.unattempted || 0}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Topic Performance */}
                    {testResults[0]?.topicPerformance && (
                      <div>
                        <h5 className="text-sm font-medium text-gray-700 mb-2">
                          Topic Performance
                        </h5>
                        <div className="space-y-2">
                          {testResults[0].topicPerformance
                            .slice(0, 3)
                            .map((topic, index) => (
                              <div
                                key={index}
                                className="flex justify-between items-center p-2 bg-gray-50 rounded"
                              >
                                <span className="text-sm text-gray-600">
                                  {topic.topic}
                                </span>
                                <div className="flex items-center space-x-2">
                                  <span className="text-xs text-gray-500">
                                    {topic.correct}/{topic.total}
                                  </span>
                                  <div className="w-16 bg-gray-200 rounded-full h-1.5">
                                    <div
                                      className="bg-blue-600 h-1.5 rounded-full"
                                      style={{
                                        width: `${
                                          (topic.correct / topic.total) * 100
                                        }%`,
                                      }}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    )}

                    {/* Strengths & Weaknesses */}
                    {testResults[0]?.strengths &&
                      testResults[0]?.weaknesses && (
                        <div className="space-y-3">
                          <div>
                            <h5 className="text-sm font-medium text-green-700 mb-1">
                              Strengths
                            </h5>
                            <div className="flex flex-wrap gap-1">
                              {testResults[0].strengths
                                .slice(0, 3)
                                .map((strength, index) => (
                                  <span
                                    key={index}
                                    className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-green-100 text-green-700"
                                  >
                                    {strength}
                                  </span>
                                ))}
                            </div>
                          </div>

                          <div>
                            <h5 className="text-sm font-medium text-red-700 mb-1">
                              Areas to Improve
                            </h5>
                            <div className="flex flex-wrap gap-1">
                              {testResults[0].weaknesses
                                .slice(0, 3)
                                .map((weakness, index) => (
                                  <span
                                    key={index}
                                    className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-red-100 text-red-700"
                                  >
                                    {weakness}
                                  </span>
                                ))}
                            </div>
                          </div>
                        </div>
                      )}

                    {/* Recommendations */}
                    {testResults[0]?.recommendations && (
                      <div>
                        <h5 className="text-sm font-medium text-gray-700 mb-2">
                          Recommendations
                        </h5>
                        <ul className="text-xs text-gray-600 space-y-1">
                          {testResults[0].recommendations
                            .slice(0, 2)
                            .map((rec, index) => (
                              <li key={index} className="flex items-start">
                                <span className="inline-block w-1 h-1 bg-gray-400 rounded-full mt-1.5 mr-2 flex-shrink-0"></span>
                                {rec}
                              </li>
                            ))}
                        </ul>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="text-center py-6">
                    <p className="text-sm text-gray-500">
                      Take a test to see performance insights
                    </p>
                  </div>
                )}
              </div>
            </div>

            {/* Mentoring Sessions */}
            <div className="bg-white shadow rounded-lg overflow-hidden">
              <div className="px-6 py-5 border-b border-gray-200 flex justify-between items-center">
                <h2 className="text-xl font-bold text-gray-800">
                  Mentoring Sessions
                </h2>
                <Link
                  to="/mentoring"
                  className="text-sm font-medium text-gray-700 hover:text-gray-900"
                >
                  Book session
                </Link>
              </div>

              <div className="p-6">
                {isLoading ? (
                  <div className="flex justify-center">
                    <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-gray-700"></div>
                  </div>
                ) : bookings.length > 0 ? (
                  <div className="space-y-4">
                    {bookings.slice(0, 3).map((booking) => (
                      <div key={booking.id} className="border rounded-lg p-4">
                        <div className="flex items-center justify-between">
                          <div>
                            <h4 className="font-medium text-gray-900">
                              {booking.mentorName || "Mentor Session"}
                            </h4>
                            <p className="text-sm text-gray-500 mt-1">
                              {booking.topic || "General Discussion"}
                            </p>
                            <div className="flex items-center mt-2 space-x-4">
                              <span className="text-xs text-gray-500">
                                {booking.date || "TBD"} at{" "}
                                {booking.time || "TBD"}
                              </span>
                              <span
                                className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${
                                  booking.status === "confirmed"
                                    ? "bg-green-100 text-green-800"
                                    : booking.status === "paid"
                                    ? "bg-blue-100 text-blue-800"
                                    : "bg-yellow-100 text-yellow-800"
                                }`}
                              >
                                {booking.status || "pending"}
                              </span>
                            </div>
                          </div>
                          <div className="text-right">
                            <p className="text-sm font-medium text-gray-900">
                              ₹{booking.fee || 0}
                            </p>
                            <p className="text-xs text-gray-500">
                              {booking.sessionType || "one-on-one"}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-6">
                    <svg
                      className="mx-auto h-12 w-12 text-gray-400"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M18 7.5v3m0 0v3m0-3h3m-3 0h-3"
                      />
                    </svg>
                    <h3 className="mt-2 text-sm font-medium text-gray-900">
                      No sessions booked
                    </h3>
                    <p className="mt-1 text-sm text-gray-500">
                      Book a mentoring session to get personalized guidance.
                    </p>
                    <div className="mt-6">
                      <Link
                        to="/mentoring"
                        className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gray-800 hover:bg-gray-700"
                      >
                        Book Session
                      </Link>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
